module.exports = __webpack_public_path__ + "static/em_capabilities_3_1-dc28c413760081e4f322ae979edbcba0.png";